<template>
  <div class="manage-groups-table__container">
    <div class="container mt-30">
      <div class="card m-b-30">
        <div class="card-body" v-if="count > 0">
          <div class="mb-35">
            <h4 class="mt-0 groups-title p-15">
              Groups
              <span class="badge badge-secondary ml-5">{{ count }}</span>
            </h4>
          </div>
          <BaseTable :data="groups" :columnMetaData="columnMetaData" :columnNames="columnNames" @onSortColumn="onSortColumn">
            <template slot="name" slot-scope="{ data }">
              <span @click="onEditGroup(data.row)" class="cursor-pointer">
                {{ data.row.name }}
              </span>
            </template>
            <template slot="actions" slot-scope="{ data }">
              <img src="static/img/activity-configurator/edit-tag.svg" @click="onEditGroup(data.row)" class="mr-20 cursor-pointer" alt="" />
              <img src="static/img/activity-configurator/delete-tag.svg" @click="onDeleteGroup(data.row)" class="cursor-pointer" alt="" />
            </template>
          </BaseTable>
        </div>
        <div class="card-body" v-if="count == 0">
          <div class="mb-35">
            <h4 class="mt-0 groups-title p-15">
              Groups
              <span class="badge badge-secondary ml-5">{{ count }}</span>
            </h4>
          </div>
          <div class="text-center fs-16 mb-15 font-weight-bold">
            <b>No available groups.</b>
          </div>
        </div>

        <div class="row display-inline-flex manage-groups-table__pagination" v-if="count > 0">
          <div class="arrow-icon cursor_pointer" @click="onPageChange(-1)">
            <i class="fa fa-angle-left fs-23 pt-3"></i>
          </div>
          <div class="pagination pt-3">
            {{ pagination && pagination.current }}
          </div>
          <div class="pagination2 pt-3">of {{ pagination && pagination.total }}</div>
          <div @click="onPageChange(1)" class="arrow-icon pt-3 cursor_pointer">
            <i class="fa fa-angle-right fs-23"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const columnMetaData = {
  name: {
    name: "name",
    heading: "Group name",
    contentClasses: ["p-5, pl-30", "name"],
    fixedWidth: "20%",
    sortable: true,
    headerClasses: ["pl-35"],
    isRenderCustomComponent: true
  },

  desc: {
    name: "desc",
    heading: "Description",
    contentClasses: ["pt-5 pb-5", "fs-11"],
    fixedWidth: "55%",
    headerClasses: []
  },

  created_by: {
    name: "created_by",
    heading: "Created By",
    contentClasses: ["pt-5 pb-5", "fs-12"],
    fixedWidth: "15%",
    sortable: true,
    headerClasses: []
  },

  actions: {
    name: "actions",
    heading: "",
    contentClasses: ["pt-5 pb-5"],
    fixedWidth: "10%",
    sortable: false,
    headerClasses: [],
    isRenderCustomComponent: true
  }
};

import BaseTable from "@/components/activity-library/base-table";

export default {
  data() {
    return {
      columnMetaData,
      columnNames: ["name", "desc", "created_by", "actions"]
    };
  },

  components: {
    BaseTable
  },

  props: {
    groups: {},
    count: {},
    pagination: {}
  },

  methods: {
    onEditGroup(tag) {
      this.$emit("editGroup", tag);
    },
    onDeleteGroup(tag) {
      this.$emit("deleteGroup", tag);
    },
    onSortColumn(eventData) {
      this.$emit("onSortColumn", eventData);
    },
    onPageChange(direction) {
      this.$emit("onPageChange", direction);
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-name {
  height: 24px;
  font-family: "RobotoRegular";
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #4c8ce4;
}

.description {
  width: 50%;
}

.created-by {
  width: 20%;
}

.actions {
  width: 10%;
}

.groups-title {
  height: 24px;
  font-family: "RobotoRegular";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.manage-groups-table {
  &__container {
    margin: 0 auto;

    .card-body {
      padding: 0;
    }

    .container {
      max-width: 100%;
    }

    .card {
      border: none;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
      margin-bottom: 50px;
    }

    .cursor-pointer {
      cursor: pointer;
    }
  }

  &__pagination {
    margin-left: 25px !important;
    margin-bottom: 40px;
  }
}

.badge-secondary {
  background-color: #b0bac9;
  position: relative;
  bottom: 3px;
}
.arrow-icon {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #e4e8eb;
}

.pagination {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 11px !important;
}

.pagination2 {
  width: 40px;
  height: 32px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}

.disabledPagination {
  pointer-events: none;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
